import React, { useEffect, useState } from 'react';
import { ConfirmParkinglot, LinkExpiry, GetSchedulingPhone } from '../appointments/create/api';
import Typography from "@material-ui/core/Typography";
import { Grid, Button, makeStyles } from "@material-ui/core";

// update log
// FB 4661 BR    08/30/2021    PE - ParkingLot confirmation url
// FB 4810 MS    11/22/2021    Fixed multiple calls to API issue
// FB 4867 DK    12/27/2021    Added screens for Support files and Health forms upload


function Parkinglotconfirm(props: any) {
  const [returnValue, setReturnValue] = useState("");
  const [linkExpiryData, setLinkExpiryData] = useState("");
  const [SchedulingPoneData, setSchedulingPoneData] = useState("");
  const [displayMessage, setDisplayMessage] = useState("");
  const [assisstanceMessage, setAssisstanceMessage] = useState("");
  const [fontColor, setFontColor] = useState("limegreen");

  useEffect(() => {
    onload();
  }, []);   //FB 4810

  const onload = async () => {
    const MessageData = await ConfirmParkinglot(props.match.params.apptId, props.match.params.licenseName);  //FB 4867
    setReturnValue(MessageData);
    const linkExpiryReturnData = await LinkExpiry(props.match.params.apptId, props.match.params.licenseName);  //FB 4867
    setLinkExpiryData(linkExpiryReturnData);
    const SchedulingPhoneReturnData = await GetSchedulingPhone(props.match.params.apptId, props.match.params.licenseName);  //FB 4867
    setSchedulingPoneData(SchedulingPhoneReturnData);
    //FB 4810 BEGIN
    if (MessageData == "Appointment is cancelled") {
      setDisplayMessage("Your appointment is cancelled");
      setAssisstanceMessage("For further assistance please call:" + SchedulingPhoneReturnData);
      setFontColor("red");
    } else {
      if (linkExpiryReturnData == "Appointment is in the past") {
        setDisplayMessage("Your appointment date is already passed.");
        setAssisstanceMessage("For further assistance please call:" + SchedulingPhoneReturnData);
        setFontColor("red");
      }
      else {
        if (MessageData == "Patient Arrival is confirmed") {
          setDisplayMessage("Our office will be notified of your arrival.");
          setAssisstanceMessage("");
          setFontColor("limegreen");
        }
        else {
          setDisplayMessage("There was an error confirming your arrival.");
          setAssisstanceMessage("For further assistance please call:" + SchedulingPhoneReturnData);
          setFontColor("red");
        }
        //FB 4810 END
      }
    }

  }
  const useStyles = makeStyles({
    active: {
      backgroundColor: "#18a2b8",
      color: "white",
      textTransform: "capitalize",
      borderRadius: "15px",
      marginLeft: "20px",
      "&:hover": {
        backgroundColor: "#18a2b8",
      },
    },
  });

  const classes = useStyles();

  return (
    <div>
      <Grid
        lg={12}
        md={12}
        sm={12}
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "2%"
        }}
      >
        {/* <Box component="fieldset" mb={12} style={{display: "flex", alignItems: "center",justifyContent:"center"}} borderColor="transparent"> */}
        <Typography variant="h5" style={{ color: fontColor }} component="legend">
          <br></br>
          {displayMessage}
          <br></br>
          {assisstanceMessage}
        </Typography>
        {/* </Box> */}
      </Grid>
    </div>
  );



}
export default Parkinglotconfirm;